import pages from './pages';

const menuItems = {
    items: [pages]
};

export default menuItems;
